import dayjs from 'dayjs';
import { toNumber } from 'lodash';

import { RAW_DATE_FORMAT } from '@/common/constants';

import { useUpdateContributionRecordsQuery } from './queries/useUpdateContributionRecords.query';
import { ChangedContributionRecord } from './useChangedContributionRecords.store';

interface Props {
  contributionId?: string;
  requestVersion?: number;
  onSuccess?: () => void;
  onError?: (errorText?: string) => void;
}

export const useUpdateChangedContributionRecords = ({
  contributionId,
  requestVersion,
  onSuccess,
  onError,
}: Props) => {
  const {
    updateContributionRecords,
    isLoading: isUpdating,
  } = useUpdateContributionRecordsQuery(contributionId, requestVersion, undefined, onError);

  const updateChangedContributionRecords = async (changedContributionRecords: ChangedContributionRecord[]) => {
    const recordsToUpdate = changedContributionRecords
      .filter((item) => item?.recordId);

    try {
      if (recordsToUpdate.length) {
        await updateContributionRecords(recordsToUpdate.map((item) => ({
          ...item?.recordId ? { record_id: toNumber(item?.recordId) } : {},
          ...item?.employeeContributionAmount ? { ee_amount: toNumber(item?.employeeContributionAmount) } : {},
          ...item?.employerContributionAmount ? { er_amount: toNumber(item?.employerContributionAmount) } : {},
          ...item?.contributionDateOn ? { date: dayjs(item.contributionDateOn).format(RAW_DATE_FORMAT), } : {},
          ...item?.taxYear ? { tax_year: item?.taxYear, } : {},
          ...item?.taxType ? { tax_type: item?.taxType, } : {},
          ...item?.memo ? { memo: item?.memo, } : {},
          ...typeof item?.isDeleted === 'boolean' ? { disabled: item?.isDeleted } : {},
        })));
      }

      if (onSuccess) {
        onSuccess();
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  return {
    isLoading: isUpdating,
    updateChangedContributionRecords,
  };
};
